import { 
    SET_LOADING,
    SET_MOBILE_NO,
    SET_OTP_LOGIN,
    SET_OTP_VERIFICATION,
    SET_USERNAME,
    SET_USER_ID
} from "../../actions/auth/types";

const INITIAL_STATE = {
    userId : "",
    otpLoginData : "",
    loading: false,
    userData: null,
    mobileNo: '',
    username: '',
}

const AuthReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER_ID: {
            return {
                ...state,
                userId: action.payload
            }
        }
        case SET_OTP_LOGIN: {
            return {
                ...state,
                otpLoginData : action.payload
            }
        }
        case SET_OTP_VERIFICATION: {
            return {
                ...state,
                userData: action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_USER_ID: {
            return {
                ...state,
                userId: action.payload
            }
        }
        case SET_MOBILE_NO: {
            return {
                ...state,
                mobileNo: action.payload
            }
        }
        case SET_USERNAME: {
            return {
                ...state,
                username: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default AuthReducer